module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/086-nigeria-9f7980a6181df7fbed2951978ca43138.svg";